import React from 'react';
import { useSelector } from 'react-redux';
import { familyCalendarModalTariffs } from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import type { RootState } from 'reactApp/store';
import type { Product } from 'reactApp/types/Billing';
import { FamilyCard } from 'reactApp/ui/IframePages/BuyFamilyTariff/FamilyCard/FamilyCard';
import { FamilyCardLoader } from 'reactApp/ui/IframePages/BuyFamilyTariff/FamilyCardLoader/FamilyCardLoader';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

import styles from './FamilyTariffList.css';

interface FamilyTariffListProps {
    activeTab: ETabsName;
    onBuyClick: (product: Product) => void;
}

export const FamilyTariffList: React.FC<FamilyTariffListProps> = ({ activeTab, onBuyClick }) => {
    const { isLoading, isLoaded } = useSelector(ProductsSelectors.getLifeCycleState);
    const { month, year } = familyCalendarModalTariffs;
    const tariffs = useSelector((state: RootState) =>
        ProductsSelectors.getNormalizedProductsBySpace(state, activeTab === ETabsName.month ? month : year)
    );
    const tariffValues = Object.values(tariffs);

    return (
        <div className={styles.root}>
            {isLoaded &&
                tariffValues.map((products, index) => {
                    const product = activeTab === ETabsName.month ? products.monthProduct : products.yearProduct;
                    if (product) {
                        return (
                            <FamilyCard key={index} product={product} activeTab={activeTab} focused={index === 1} onBuyClick={onBuyClick} />
                        );
                    }
                })}
            {isLoading && Array.from(new Array(month.length)).map((_, idx) => <FamilyCardLoader key={idx} />)}
        </div>
    );
};
